import { createContext, FC, PropsWithChildren, useContext } from 'react';

import { DisabledContext, useDisabled } from '@hh.ru/magritte-common-use-disabled';

const LoadingContext = createContext(false);

export const LoadingContextProvider: FC<PropsWithChildren<{ loading?: boolean }>> = ({ loading, children }) => {
    const disabled = useDisabled();
    return (
        <LoadingContext.Provider value={loading || false}>
            <DisabledContext.Provider value={loading || disabled}>{children}</DisabledContext.Provider>
        </LoadingContext.Provider>
    );
};

export const useLoadingState = (): boolean => useContext(LoadingContext);
